<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="编号：" prop="cityCompanyId">
            <el-input
              v-model="query.cityCompanyId"
              placeholder="请输入编号"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item label="城市公司：" prop="cityCompanyName">
            <el-input
              v-model="query.cityCompanyName"
              placeholder="请输入城市公司"
              size="small"
              clearable
            />
          </el-form-item>
          <!-- <el-form-item label="通商云ID：" prop="tsyId">
            <el-input v-model="query.tsyId" placeholder="请输入通商云ID" size="small" clearable />
          </el-form-item> -->
          <el-form-item label="状态：">
            <el-select
              v-model="query.state"
              placeholder="请选择"
              clearable
              size="small"
            >
              <!-- <el-option label="全部" value=""></el-option> -->
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini"
              >搜索</el-button
            >
            <el-button type="info" @click="handleFilter" plain size="mini"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button
            type="primary"
            size="mini"
            @click="handleDownload"
            plain
            v-hasPermi="['business:cityCorporation:export']"
            >导出</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="handleCreate(0, '')"
            icon="el-icon-plus"
            v-hasPermi="['business:cityCorporation:add']"
            >新建城市公司</el-button
          >
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list">
        <el-table-column type="selection" width="50" />
        <el-table-column label="编号" prop="id" align="center" fixed>
        </el-table-column>
        <el-table-column
          label="城市公司名称"
          prop="name"
          align="center"
          width="160"
          fixed
        >
          <template slot-scope="{ row }">
            <div @click="handleShowDetail(row.id)">
              <el-link type="primary">{{ row.name }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="负责人" prop="chargeName" align="center" />
        <el-table-column
          label="手机号码"
          prop="pho"
          align="center"
          width="160"
        />
        <!-- <el-table-column label="大区人数" prop="companyAreaNum" align="center">
          <template slot-scope="{row}">
            <div @click="handleShow(row)">
              <el-link type="primary">{{row.companyAreaNum}}</el-link>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="客户人数" prop="customerNum" align="center" />
        <el-table-column label="省市区" prop="" align="center" width="200">
          <template slot-scope="{ row }">
            {{ row.addrProvince }}-{{ row.addrCity }}-{{ row.addrArea }}
          </template>
        </el-table-column>
        <el-table-column
          label="管辖区域数量"
          prop=""
          align="center"
          width="130"
        >
          <template slot-scope="{ row }">
            <el-link type="primary" @click="showArea(row)">{{
              row.addrAreaCount
            }}</el-link
            ><br />
          </template>
        </el-table-column>
        <el-table-column
          label="地址"
          prop="addrDetail"
          align="center"
          width="200"
        />
        <!-- <el-table-column label="通商云id" prop="" align="center">
          <template slot-scope="{ row }">
            {{ row.bizUserId }}
          </template>
        </el-table-column> -->
        <el-table-column
          label="入驻时间"
          prop="checkInTime"
          sortable="custom"
          align="center"
          width="200"
        />
        <!-- <el-table-column label="同意时间" prop="auditTime" sortable="custom" align="center" width="200" /> -->
        <el-table-column
          label="修改时间"
          prop="operatedTime"
          sortable="custom"
          align="center"
          width="200"
        />
        <el-table-column label="状态" prop="" align="center" width="200">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.state"
              active-text="启用"
              inactive-text="禁用"
              :active-value="true"
              :inactive-value="false"
              @change="handleState(row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operatedBy" align="center" />
        <el-table-column label="操作" align="center" fixed="right" width="250">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="handleCreate(1, row)"
              v-hasPermi="['business:cityCorporation:edit']"
              >编辑</el-button
            >
            <!-- <el-button type="text" @click="handleAddAreaVue(row)">添加区域</el-button>
            <el-button type="text" @click="handleRemoveAreaVue(row)">移除区域</el-button> -->
            <el-button type="text" @click="handleAdjustArea(row)"
              >调整区域</el-button>
              <el-button type="text" @click="handlecityCompanyQrcode(row)"
              >静态码管理</el-button>
            <!-- <el-button type="text" @click="handleWithdraw(row)" v-hasPermi="['business:cityCorporation:withd']">提现</el-button> -->
            <!-- <el-button type="text" @click="handleApply(row)" v-hasPermi="['business:cityCorporation:commun']">{{row.tongShangYunPO && row.tongShangYunPO.status==2?'通联账户':'注册通联'}}</el-button> -->
            <el-button type="text" @click="handleUpdate(row)"
              >日志记录</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :pageNo.sync="query.pageNo"
        :pageSize.sync="query.pageSize"
        @pagination="doQueryList"
      />
    </el-card>
    <el-dialog
      title="管辖区域"
      :visible.sync="formVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <div class="dialog-box">
        <el-tree :data="areaOptions" :props="defaultProps"></el-tree>
      </div>
    </el-dialog>
    <!-- 新建表单 -->
    <city-add
      ref="cityAdd"
      @created="doQueryList({})"
      :addressList="addressList"
    />
    <!-- 查看大区 -->
    <region-show ref="regionShow" @created="doQueryList({})" />
    <!-- 提现 -->
    <withdraw ref="withdraw" @created="doQueryList({})" />
    <!-- 注册通联 -->
    <accountApply ref="account" @created="doQueryList({})" />
    <add-area-vue ref="addAreaVue" @created="doQueryList({})" />
    <area-remove-vue ref="areaRemoveVue" @created="doQueryList({})" />
    <area-adjust ref="areaAdjust" @created="doQueryList({})" />
  </div>
</template>

<script>
import cityCompanyApi from "@/api/sys/cityCompany";
import Pagination from "@/components/Pagination";
import sysAddrApi from "@/api/sys/sysAddr";
import sysTongshangyunApi from "@/api/sys/tongshangyun";
import cityAdd from "./add";
import withdraw from "./withdraw";
import accountApply from "./accountApply";
import regionShow from "./regionShow";
import addAreaVue from "./addArea.vue";
import areaRemoveVue from "./areaRemove.vue";
import areaAdjust from "./areaAdjust.vue";
import CityCompanyAddrAreaApi from "@/api/sys/CityCompanyAddrArea";
// import customerLevelApi from '@/api/sys/customerLevel'
export default {
  components: {
    Pagination,
    cityAdd,
    regionShow,
    withdraw,
    accountApply,
    addAreaVue,
    areaRemoveVue,
    areaAdjust
  },
  data() {
    return {
      formVisible: false,
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        state: null
        // customerType: 2
      },
      popType: 0,
      addressList: [],
      dateTime: null,
      areaOptions: [], // 添加 areaOptions 初始化
      defaultProps: {
        children: "child",
        label: "areaName"
      }
    };
  },
  filters: {
    setState(val) {
      switch (val) {
        case 1:
          return "招募业务员";
        case 3:
          return "修改身份";
        case 4:
          return "离职";
        default:
          return val;
      }
    }
  },
  created() {
    this.doQueryList({
      pageNo: 1
    });
    this.getAddressList();
  },
  methods: {
    showArea(row) {
      if (!row.addrAreaCount) return;
      CityCompanyAddrAreaApi.CityCompanyAddrAreaListForTree({
        cityCompanyId: row.id
      }).then(({ data }) => {
        this.areaOptions = data ? this.formatCascaderData(data) : [];
        this.formVisible = true;
      });
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child);
        }
      }
      return data;
    },
    handleAddAreaVue(row) {
      this.$refs.addAreaVue.handleCreate(row);
    },
    handleRemoveAreaVue(row) {
      this.$refs.areaRemoveVue.handleUpdate(row);
    },
    handleAdjustArea(row) {
      this.$refs.areaAdjust.handleUpdate(row);
    },
    handleUpdate(row) {
      // if(type==3){
      this.$router.push("/log/log?type=30&id=" + row.id);
      // }
    },
    //跳转静态码管理
    handlecityCompanyQrcode(row) {
      this.$emit('handleShow', row.id, 3);
    },
    async handleApply(row) {
      const { data } = await sysTongshangyunApi.getMemberInfo({
        userId: row.userId
      });
      // return
      if (data.status == 1) {
        this.$common.showMsg("warning", "提交的账户申请，正在审核中");
      } else if (data.status == 3) {
        this.$confirm("审核失败, 是否重新提交?", "", {
          confirmButtonText: "重新提交",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$refs.account.handleCreate({ data, id: row.userId });
          })
          .catch(() => {});
      } else {
        this.$refs.account.handleCreate({ data, id: row.userId });
      }
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10
      };
      this.doQueryList({
        pageNo: 1
      });
    },
    handleShow(row) {
      this.$refs.regionShow.handleCreate({
        id: row.id,
        num: row.companyAreaNum
      });
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      });
    },
    // 修改状态
    async handleState(row) {
      console.log("row: ", row);
      const res = await cityCompanyApi.cityCompanyEnableDisable({
        id: row.id,
        state: row.state
      });
      // console.log('res: ',res);
      if (res.code == 0) {
        this.$message.success("状态修改成功");
      }
    },
    // 提现
    handleWithdraw(row) {
      this.$refs.withdraw.handleCreate(row);
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo;
      }
      if (pageSize) {
        this.query.pageSize = pageSize;
      }
      let query = {
        ...this.query
      };
      if (query.state === "") {
        delete query.state;
      }
      // this.query.displayPosition=this.activeName
      this.listLoading = true;
      return cityCompanyApi
        .fetchList(query)
        .then(({ data }) => {
          console.log("data: ", data);
          this.list = data.list;
          this.total = data.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    // 获取区域列表
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({ data }) => {
        this.addressList = this.formatCascaderData(data);
        // console.log('地区列表: ',data);
      });
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child);
        }
      }
      return data;
    },
    /**
     * 打开新建表单
     */
    handleCreate(type, row) {
      this.$refs.cityAdd.handleCreate({
        id: row.id,
        type,
        row
      });
    },
    //查看信息
    handleShowDetail(id) {
      this.$emit("handleShow", id, 2);
    },
    handleDownload() {
      this.$router.push("/export/list?code=ExportCityCompanyDownload");
    }
  }
};
</script>
